// src/pages/post/Post.jsx
import "./post.css";
import SinglePost from "../../components/singlePost/SinglePost";
import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import { Context } from "../../context/Context";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import SubscribeOrSharePopup from "../../components/subscribeOrSharePopup/subscribeOrSharePopup";
import SignUpPopup from "../../components/popUps/SignUpPopup";
import axios from "axios";

export default function Post() {
  const { handleViewIncrement, userViews, user } = useContext(Context);
  const location = useLocation();
  const articleId = location.pathname.split("/")[1];

  const [showSignUpPopup, setShowSignUpPopup] = useState(false);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const popupRef = useRef(null);

  const [subscriptionChecked, setSubscriptionChecked] = useState(false);

  // Fetch User Subscription Details
  const fetchUserSubscription = useCallback(async () => {
    try {
      const res = await axios.get(`/users/${user.userId}`);
      if (res.status === 200) {
        const { subscription } = res.data;
        if (subscription?.plan !== "plan") {
          setIsSubscribed(true);
        }
      } else {
        toast.info(res.data.message);
      }
    } catch (error) {
      console.error("Error fetching user subscription details", error);
      toast.error("Error fetching user subscription details!");
    } finally {
      setSubscriptionChecked(true);
    }
  }, [user?.userId]);

  // Close SubscribeOrSharePopup if clicked outside
  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      // Manually trigger the popup's internal close logic
      if (popupRef.current?.handleClose) {
        popupRef.current.handleClose();
      }
    }
  };

  // Add/Remove event listener for closing SubscribeOrSharePopup
  useEffect(() => {
    if (showSubscribePopup) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showSubscribePopup]);

  // Check if user is subscribed and handle popups accordingly
  useEffect(() => {
    handleViewIncrement(articleId);
    if (user?.userId) fetchUserSubscription();
  }, [user, articleId, fetchUserSubscription]);

  useEffect(() => {
    if (!subscriptionChecked) return;

    let timer;

    const isPrivilegedRole = user?.role > 1; // Writer, Editor, Admin, SuperAdmin
    const hasFullAccess = isSubscribed || isPrivilegedRole;

    if (hasFullAccess) {
      setShowSignUpPopup(false);
      setShowSubscribePopup(false);
    } else {
      if (!user || userViews > 5) {
        setShowSignUpPopup(true);
        setShowSubscribePopup(false);
      } else {
        timer = setTimeout(() => {
          setShowSignUpPopup(false);
          setShowSubscribePopup(true);
        }, 5000);
      }
    }

    return () => {
      if (timer) clearTimeout(timer); // ✅ safe cleanup
    };
  }, [user, isSubscribed, userViews, subscriptionChecked]);

  return (
    <div className="single">
      {subscriptionChecked && showSubscribePopup && (
        <SubscribeOrSharePopup
          ref={popupRef}
          onClose={() => setShowSubscribePopup(false)}
        />
      )}
      {subscriptionChecked && showSignUpPopup && <SignUpPopup />}
      <SinglePost />
    </div>
  );
}
